import { Colors } from '@user-portal/wikr-components';
import { ButtonHTMLAttributes } from 'react';

import * as S from './styled';

type Props = ButtonHTMLAttributes<HTMLButtonElement> & {
    onClick?: () => void;
    withShadow?: boolean;
    size?: number;
    badgeColor?: Colors;
    backgroundColor?: Colors;
};

const BackButton = ({
    withShadow,
    onClick,
    size = 40,
    badgeColor = 'text-main',
    backgroundColor = 'surface-main',
    children,
}: Props) => {
    return (
        <S.RoundedButton
            $withShadow={Boolean(withShadow)}
            $size={size}
            onClick={onClick}
            $badgeColor={badgeColor}
            $backgroundColor={backgroundColor}
        >
            {children}
        </S.RoundedButton>
    );
};

export default BackButton;
